module.exports = __webpack_public_path__ + "img/square-arrow-down-left.b146a231.svg";